"use client";

import React, { useState } from "react";

const JobAlertForm: React.FC = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Handle the form submission, e.g., send the email to your backend or an API
    console.log("Submitting email for job alerts:", email);
    // Reset the email field or give feedback to the user
  };

  return (
    <div className="mb-4 rounded-lg border border-gray-200 p-6 shadow-lg">
      <h2 className="mb-5 text-lg font-semibold text-gray-800">
        Get notified of new job postings!
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700"
        >
          Enter your email address
        </label>
        <div className="flex rounded-md shadow-sm">
          <input
            type="email"
            name="email"
            id="email"
            required
            className="block w-full flex-1 rounded-none rounded-l-md border-gray-300 p-2 focus:border-amber-500 focus:ring-amber-500 sm:text-sm"
            placeholder="your email here"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="submit"
            className="ml-2 inline-flex items-center rounded-r-md border border-transparent bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
          >
            Create Job Alert
          </button>
        </div>
      </form>
      <p className="mt-4 text-xs text-gray-600">
        By clicking the button above, I agree to the Roamdoc Terms of Use and
        acknowledge I have read the Privacy Policy, and agree to receive email
        job alerts.
      </p>
    </div>
  );
};

export default JobAlertForm;
